type DeviceTargetingImport = {
  delimiter: {
    columnDelimiter: string;
    lineDelimiter: string;
  };
  fileName: string;
  filePath: string;
  keysToReview: any[];
  totalLines: number;
};

export async function deviceTargetingImportFile(
  user: string,
  campaignId: string,
  file: File,
  sessionId: string
): Promise<DeviceTargetingImport> {
  const params = new URLSearchParams({
    name: file.name
  }).toString();

  const res = await fetch(
    `${taptap.config.backendUrlBase}batch/import/deviceId/file/${user}/campaign/${campaignId}?${params}`,
    {
      body: new Blob([file]),
      headers: {
        'Content-Type': 'text/csv',
        'X-Requested-With': 'XMLHttpRequest',
        sessionId,
        user
      },
      method: 'POST'
    }
  );
  const data = await res.json();
  return data;
}
